import { getSupabase } from '../services/supabase';

export const requestLearningQueue = async (signal: AbortSignal) => {
  const result = await getSupabase()
    .from('student_tasks_ui_v1' as 'student_task')
    .select(
      'student_task_id,task_code,task_name,lesson_title,group_name,opens_at,due_at,closes_at,status,teacher_feedback,attempt_count,official_attempt_id,current_attempt_no,current_attempt_status,official_attempt_status,availability_state,due_state,is_available,can_act,can_manage,can_start,can_resume,can_complete',
    )
    .order('updated_at', { ascending: false })
    .limit(100)
    .abortSignal(signal);
  if (result.error) throw result.error;
  return result.data;
};
